import axios, { CancelTokenSource } from 'axios';
import { PatientEmailImportDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/patients-emails-import`;

export const uploadPatientEmailFile = (file: File, source: CancelTokenSource):
    Promise<PatientEmailImportDto[]> => {

  let bodyFormData = new FormData();
  bodyFormData.append("file", file);

  return axios
      .post(`${apiUri}`, bodyFormData, {cancelToken: source.token})
      .then(response => response.data);
}
